import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TAgcKosokuryoTarihuGetListRes,
  TAgcKosokuryoTarihuPutReq,
} from "./TAgcKosokuryoTarihu"

/**
 * AGC高速料タリフに対するAPIリクエスト用サービス
 *
 * @export
 * @class AgcKosokuryoTarihuService
 * @extends {ConnectApi}
 */
export default class AgcKosokuryoTarihuService extends ConnectApi {
  /**
   * AGC高速料タリフ 一覧取得
   *
   * @param {(param: TApiResponse<TAgcKosokuryoTarihuGetListRes>) => any} resolve
   * @param {(param: TApiResponse<TAgcKosokuryoTarihuGetListRes>) => any} reject
   * @memberof AgcKosokuryoTarihuService
   */
  getList = async () => {
    try {
      const res: AxiosResponse<TApiResponse<TAgcKosokuryoTarihuGetListRes[]>> =
        await this.getInner(`/billing/agckosokuryo`)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * AGC高速料タリフ 更新
   *
   * @param {TAgcKosokuryoTarihuPutReq} data
   * @param {(param: TApiResponse<TAgcKosokuryoTarihuGetListRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TAgcKosokuryoTarihuGetListRes[]>>) => any} reject
   * @memberof AgcKosokuryoTarihuService
   */
  putList = async (data: TAgcKosokuryoTarihuPutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/billing/agckosokuryo`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体削除
   *
   * @param {string} data
   * @param {(param: TApiResponse<TAgcKosokuryoTarihuGetListRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TAgcKosokuryoTarihuGetListRes>>) => any} reject
   * @memberof AgcKosokuryoTarihuService
   */
  delete = async (id: string, data: { 更新日時: string }) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `billing/agckosokuryo/actions/delete/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
